import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import BTCRailCard from '../btcTracker/BTCRailCard';
import DailyVisitRail from '../dailyVisit/DailyVisitRail';
import PushNudgeRail from '../notifications/PushNudgeRail';
import clsx from 'clsx';

export default function FeedHighlightsRail({
  showMeme = false,
  showBtc = true,
}) {
  const scrollerRef = useRef(null);
  const [isSolo, setIsSolo] = useState(false);
  const cards = [];
  if (showBtc) cards.push(<BTCRailCard key="btc" />);
  cards.push(
    <PushNudgeRail product="connect" hideWhenSubscribed key="push" />,
  );
  if (showMeme) {
    cards.push(
      <Link
        key="meme"
        to="/meme"
        className="feedHighlightCard feedHighlightCard--meme"
      >
        <div className="feedHighlightTitle">Meme Machine</div>
        <div className="feedHighlightMeta">Open /meme</div>
      </Link>,
    );
  }

  useEffect(() => {
    const node = scrollerRef.current;
    if (!node) return;
    const children = Array.from(node.children).filter(
      (child) => child && child instanceof HTMLElement && child.offsetParent !== null,
    );
    setIsSolo(children.length === 1);
  }, [cards]);

  return (
    <div className="feedHighlightsRail">
      <DailyVisitRail />
      <div
        className={clsx('feedHighlightsScroller', {
          'feedHighlightsScroller--solo': isSolo,
        })}
        ref={scrollerRef}
      >
        {cards}
      </div>
    </div>
  );
}
